import {FileUpload3} from './FileUpload3.js'
export default function Test3(){
    return(
        <div>
            <div>
                <FileUpload3 />
            </div>
        </div>
    )
}